import type { TimeFilterConfiguration } from '@grandvisionhq/appointments'

const config: TimeFilterConfiguration = [
  {
    name: 'option1',
    from: '08:00',
    until: '11:59',
  },
  {
    name: 'option2',
    from: '12:00',
    until: '15:59',
  },
  {
    name: 'option3',
    from: '16:00',
    until: '21:59',
  },
]

export const getTimeFiltersConfig = () => config
